import React from "react";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ApplicationPaths } from "../../Services/Auth/AuthConstants";

export function EmailNotFound() {

    return (
        <Container>
            <header>
                <Link to="/" className="text-pp-secondary font-weight-bolder">PHYSICIAN PORTAL</Link>
                <br />
                <h3 className="font-weight-bolder mt-1 mb-4">Email Not Found</h3>
            </header>
            <Card className="mb-3">
                <Alert className="pp-font-size-smaller font-weight-bolder" variant="pp-alert-danger">
                    <p>The email address you entered was not found.  If you have an active ABPN Physician Portal account, please try again.  
                        If you do not have an account, click <Link to={ApplicationPaths.SearchForAccount}>First-time User</Link> and follow instructions.
                    </p>
                </Alert>
                <Card.Body>
                    <Row>
                        <Col>
                            <Link to="/">
                                <Button type="submit" variant="pp-primary">Login</Button>
                            </Link>
                            <Link to={ApplicationPaths.SearchForAccount}>
                                <Button variant="outline-pp-primary" className="ml-4">First-time User</Button>
                            </Link>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default EmailNotFound;